<mat-form-field style="margin-top: 20px;">
  <mat-label class="hide-on-close">{{ 'NAV.ORGANIZATION' | translate }}</mat-label>
  <mat-select #organizationSelect (selectionChange)="onOrganizationChange()"
    (openedChange)="onSelectOpenedChange($event)" [(value)]="selectedOrganizationId"
    [disableRipple]="organizations.length === 1" [disabled]="organizations.length === 1"
    panelClass="panel-form">
    <mat-form-field appearance="outline" class="search-input">
      <input #searchInput (keydown)="onSearchKeydown($event)" (ngModelChange)="filterValueChange($event)"
        [ngModel]="filterValue" [placeholder]="'COMMON.SEARCH' | translate" autocomplete="off" matInput
        style="font-size: 12px;">
    </mat-form-field>
    <mat-option *ngFor="let o of filteredOrganizations" [id]="o.id" [value]="o.id">
      <span *ngIf="o.parentId">&nbsp;&nbsp;&nbsp;&nbsp;</span>{{o.name}}
    </mat-option>
  </mat-select>
</mat-form-field>
